__turbopack_context__.v({
  "heading": "RichText-module-scss-module__kFUOSq__heading",
});
